const timezones = [
  { text: "Hawaii: UTC -10", value: "UTC -10" },
  { text: "U.S.: UTC -9", value: "UTC -9" },
  { text: "West Canada and West USA: UTC -8", value: "UTC -8" },
  { text: "Centre-West Canada, Centre-West USA, North Mexico: UTC -7", value: "UTC -7" },
  { text: "Centre-East Canada, Centre-East USA, South Mexico: UTC -6", value: "UTC -6" },
  { text: "West South-America, East USA, East Canada: UTC -5", value: "UTC -5" },
  { text: "Centre South-America, Extreme West Canada: UTC -4", value: "UTC -4" },
  { text: "Greenland, East South-America: UTC -3", value: "UTC -3" },
  { text: "Brazilian Islands: UTC -2", value: "UTC -2" },
  { text: "Cape Verde and Azores: UTC -1", value: "UTC -1" },
  { text: "West Africa, Iceland, UK, Ireland, Portugal: UTC 0", value: "UTC 0" },
  { text: "Centre Europe, North-centre Africa, Norway, Sweden: UTC +1", value: "UTC +1" },
  { text: "East Europe, Centre-south Africa, Egypt, Libya: UTC +2", value: "UTC +2" },
  { text: "European Russia, South-west Asia, East Africa, Madagascar: UTC +3", value: "UTC +3" },
  { text: "Iran: UTC +3:30", value: "UTC +3:30" },
  { text: "Oman, Seychelles, Georgia, Armenia, Azerbaijan: UTC +4", value: "UTC +4" },
  { text: "Centre-west Russia, Centre Asia, India: UTC +5", value: "UTC +5" },
  { text: "India, Sri Lanka: UTC +5:30", value: "UTC +5:30" },
  { text: "Kazakhstan, Kyrgyztan: UTC +6", value: "UTC +6" },
  { text: "Centre-east Russia, Vietnam, Cambodia, Thailand, West Indonesia: UTC +7", value: "UTC +7" },
  { text: "West Australia, Mongolia, China, Philippines, North Indonesia: UTC +8", value: "UTC +8" },
  { text: "Centre Australia, South Korea, Japan, East Indonesia, Russia (Yakutsk territory): UTC +9", value: "UTC +9" },
  { text: "East Australia, Papua New Guinea, Micronesia, Russia (Vladivostok territory): UTC +10", value : "UTC +10" },
  { text: "New Caledonia, Russia (Magadan territory): UTC +11", value: "UTC +11" },
  { text: "New Zealand, Fiji, Extreme-east of Russia: UTC +12", value: "UTC +12" },
];

export default timezones;